export class SelectedService {
  serviceId: string;
  productIds: string[];
  constructor(serviceId: string, productIds: string[]) {
    this.serviceId = serviceId;
    this.productIds = productIds;
  }
}

export default class Event {
  id!: string;
  name: string;
  podId: string;
  code: string;
  visibleToCustomer: boolean;
  startTime: number;
  endTime: number;
  timezoneOffset: number;
  capacity: number;
  address: string;
  city: string;
  ward: string;
  district: string;
  state: string;
  zipCode: string;
  facilityId?: string;
  schoolId?: string;
  isHome: boolean;
  regEmailOptional: boolean;
  regAllowSignatureOnFile: boolean;
  services: SelectedService[];
  isActive: boolean;

  constructor(
    name = "",
    podId = "",
    code = "",
    visibleToCustomer = false,
    startTime = new Date().getTime(),
    endTime = new Date().getTime(),
    timezoneOffset = new Date().getTimezoneOffset() * -1,
    capacity = 10,
    address = "",
    ward = "",
    district = "",
    city = "",
    state = "",
    zipCode = "",
    isHome = false,
    regEmailOptional = false,
    regAllowSignatureOnFile = false,
    services: SelectedService[] = [],
    isActive: boolean = true
  ) {
    this.name = name;
    this.podId = podId;
    this.code = code;
    this.visibleToCustomer = visibleToCustomer;
    this.startTime = startTime;
    this.endTime = endTime;
    this.timezoneOffset = timezoneOffset;
    this.capacity = capacity;
    this.address = address;
    this.ward = ward;
    this.district = district;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.isHome = isHome;
    this.regEmailOptional = regEmailOptional;
    this.regAllowSignatureOnFile = regAllowSignatureOnFile;
    this.services = services;
    this.isActive = isActive;
  }
}
